import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import './TabbedModules.css';

const MultipleModules = ({ tabs }) => {
  console.log("MultipleModules",tabs.length)
  const [selectedTabIndex, setTabIndex] = useState(0);

  return (
    <div className="module col-12 w-100 h-100 message-log-module">
      <div className="module-titles cursor-pointer">
        {tabs
          .map((e, index) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <span
              key={v4()}
              className={index === selectedTabIndex ? 'titles glow' : 'titles'}
              tabIndex={index}
              role="menuitem"
              id={index}
              onClick={() => setTabIndex(index)}
            >
              {e.title}
            </span>
          ))}
      </div>
      {tabs
        .map((e, index) => (
          <div
            key={v4()}
            className={index === selectedTabIndex ? 'module-content' : 'module-content hidden-style'}
          >
            {tabs[index].module}
          </div>
        ))}
    </div>
  );
};

MultipleModules.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      className: PropTypes.number,
      module: PropTypes.node,
    }),
  ).isRequired,
};

export default MultipleModules;
